<template>
    <div class="palletTable" style="width:66.3%">
        <el-table :data="tableData" border script max-height="600px">
            <el-table-column prop="totalPalletQty" :label="$t('BusinessPurchaseOrder3.Total')" align="center">
                <template #header>
                    <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.Total') }}</p>
                </template>
                <template slot-scope="{ row }">
                    <el-form-item prop="totalPalletQty">
                        <BjInputNumber v-model="row.totalPalletQty" :placeholder="$t('inputText')" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column prop="csgPallet" :label="$t('BusinessPurchaseOrder3.Hire')" align="center">
                <template #header>
                    <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.Hire') }}</p>
                </template>
                <template slot-scope="{ row }">
                    <el-form-item prop="csgPallet">
                        <BjInputNumber v-model="row.csgPallet" :placeholder="$t('inputText')" />
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column :label="$t('BusinessPurchaseOrder3.CustomerPalletQty')" align="center">
                <el-table-column prop="standardPallet" :label="$t('BusinessPurchaseOrder3.Standard')" align="center">
                    <template #header>
                        <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.Standard') }}</p>
                    </template>
                    <template slot-scope="{ row }">
                        <el-form-item prop="standardPallet">
                            <BjInputNumber v-model="row.standardPallet" :placeholder="$t('inputText')" />
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="chepPallet" :label="$t('BusinessPurchaseOrder3.Chep')" align="center">
                    <template #header>
                        <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.Chep') }}</p>
                    </template>
                    <template slot-scope="{ row }">
                        <el-form-item prop="chepPallet">
                            <BjInputNumber v-model="row.chepPallet" :placeholder="$t('inputText')" />
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="loscomPallet" :label="$t('BusinessPurchaseOrder3.Loscom')" align="center">
                    <template #header>
                        <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.Loscom') }}</p>
                    </template>
                    <template slot-scope="{ row }">
                        <el-form-item prop="loscomPallet">
                            <BjInputNumber v-model="row.loscomPallet" :placeholder="$t('inputText')" />
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column prop="nonStandardPallet" :label="$t('BusinessPurchaseOrder3.nonStandard')" align="center">
                    <template #header>
                        <p><span class="red">*</span> {{ $t('BusinessPurchaseOrder3.nonStandard') }}</p>
                    </template>
                    <template slot-scope="{ row }">
                        <el-form-item prop="nonStandardPallet">
                            <BjInputNumber v-model="row.nonStandardPallet" :placeholder="$t('inputText')" />
                        </el-form-item>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props:{
        tableData:{
            type: Array,
            default:[]
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table .el-table__header-wrapper th{
    height: 36px!important;
}
</style>
<style lang="scss">
.palletTable p{
    margin: 0!important;
    padding: 0!important;
}
</style>